import React from "react"
import { Route } from "react-router-dom"

import Home from "./Home.js"
import Stories from "./Stories.js"
import Story from "./Story.js"
import About from "./About.js"
import References from "./References.js"
import Contacts from "./Contacts.js"

const Routes = () => [
  <Route
    key = { "home" }
    exact path = { "/" }
    component = { Home }
  />,
  <Route
    key = { "stories" }
    exact path = { "/stories" }
    component = { Stories }
  />,
  <Route
    key = { "story" }
    path = { "/stories/:story" }
    component = { Story }
  />,
  <Route
    key = { "about" }
    exact path = { "/about" }
    component = { About }
  />,
  <Route
    key = { "references" }
    exact path = { "/references" }
    component = { References }
  />,
  <Route
    key = { "contacts" }
    exact path = { "/contacts" }
    component = { Contacts }
  />
]

export default Routes


// WEBPACK FOOTER //
// ./src/containers/Routes.js